import * as React from "react";
import ReactDOM from "react-dom";

import { ICandyComponentHandle, isCandyComponentHandle } from "../ComponentHandleRegistry/ICandyComponentHandle";
import { toHtmlElementOrNull } from "../../../Controls/Commons/DOM/DomHelpers";

export type ControlReference = HTMLElement | React.ReactInstance | ICandyComponentHandle;

export function getAnchorElementByControlReferenceOrUndefined(
    controlReference: undefined | null | ControlReference
): HTMLElement | undefined {
    if (controlReference == undefined) {
        return undefined;
    }
    if (isCandyComponentHandle(controlReference)) {
        return controlReference.getAnchorElement();
    }
    try {
        const element = ReactDOM.findDOMNode(controlReference);
        return toHtmlElementOrNull(element) ?? undefined;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        return undefined;
    }
}
